import React from 'react';

const OvalDotsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.4}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <ellipse cx="14" cy="14" rx="13" ry="9.5" fill="none" />
    <circle cx="9.5" cy="14" r="0.85" fill="currentColor" />
    <circle cx="14" cy="14" r="0.85" fill="currentColor" />
    <circle cx="18.5" cy="14" r="0.85" fill="currentColor" />
  </svg>
);

export default OvalDotsIcon;
